// extracted by mini-css-extract-plugin
export default {"effect":"TransitionEffect_effect__5ySmp"};